import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/smallLogo.png'
import _imports_1 from '@/assets/user/user_wh.png'
import _imports_2 from '@/assets/user/user_bl.png'
import _imports_3 from '@/assets/user/Setting.png'
import _imports_4 from '@/assets/user/Setting_bl.png'


const _hoisted_1 = {
  id: "header",
  class: "shadow"
}
const _hoisted_2 = { class: "header_logo" }
const _hoisted_3 = { class: "bo_sch_content" }
const _hoisted_4 = { class: "header_menu" }
const _hoisted_5 = { class: "menu_info" }
const _hoisted_6 = { class: "menu_item" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "menu_info" }
const _hoisted_9 = { class: "menu_item" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "menu_info" }
const _hoisted_12 = { class: "menu_item" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "header_info" }
const _hoisted_15 = { class: "api_info" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("strong", null, "X API", -1)
const _hoisted_17 = { class: "api_info" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("strong", null, "Serp API", -1)
const _hoisted_19 = { class: "user_icon" }
const _hoisted_20 = { class: "user_name" }
const _hoisted_21 = { class: "setting_icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DateRange = _resolveComponent("DateRange")!
  const _component_ModalComponents = _resolveComponent("ModalComponents")!
  const _component_UserModal = _resolveComponent("UserModal")!
  const _component_KeywordModal = _resolveComponent("KeywordModal")!
  const _component_HelperModal = _resolveComponent("HelperModal")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.router.push('/')))
        }),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_DateRange, {
            date: $setup.state.searchDate,
            onChangeDate: $setup.selectDate
          }, null, 8, ["date", "onChangeDate"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: _normalizeClass(["menu_title", { active: $setup.menu.platform.map((item) => item.idx).some((idx) => $setup.global.selectMenu === idx) }])
            }, " 플랫폼 ", 2),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.menu.platform, (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: _normalizeClass({ active: $setup.global.selectMenu === item.idx }),
                    onClick: ($event: any) => ($setup.movePage(item))
                  }, _toDisplayString(item.title), 11, _hoisted_7))
                }), 256))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              class: _normalizeClass(["menu_title", { active: $setup.menu.watcherBot.map((item) => item.idx).some((idx) => $setup.global.selectMenu === idx) }])
            }, " 왓쳐봇 ", 2),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.menu.watcherBot, (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: _normalizeClass({
                                    active: $setup.global.selectMenu === item.idx,
                                    disabled: item.isDisabled,
                                }),
                    onClick: ($event: any) => ($setup.movePage(item))
                  }, _toDisplayString(item.title), 11, _hoisted_10))
                }), 256))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              class: _normalizeClass(["menu_title", { active: $setup.menu.setting.map((item) => item.idx).some((idx) => $setup.global.selectMenu === idx) }])
            }, " 관리 ", 2),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.menu.setting, (item) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (!item.isAdmin || (item.isAdmin && $setup.user.userInfo?.clfCd === 99))
                      ? (_openBlock(), _createElementBlock("li", {
                          key: 0,
                          class: _normalizeClass({ active: $setup.global.selectMenu === item.idx }),
                          onClick: ($event: any) => ($setup.movePage(item))
                        }, _toDisplayString(item.title), 11, _hoisted_13))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 256))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("p", null, [
            _hoisted_16,
            _createTextVNode(" " + _toDisplayString($setup.numberFormat($setup.apiCount.totalX ? $setup.apiCount.totalX : 0)) + "건 | " + _toDisplayString($setup.numberFormat($setup.apiCount.leftX ? $setup.apiCount.leftX : 0)) + "건 사용가능 ", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("p", null, [
            _hoisted_18,
            _createTextVNode(" " + _toDisplayString($setup.numberFormat($setup.apiCount.totalSerp ? $setup.apiCount.totalSerp : 0)) + "건 | " + _toDisplayString($setup.numberFormat($setup.apiCount.leftSerp ? $setup.apiCount.leftSerp : 0)) + "건 사용가능 ", 1)
          ])
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["user_info", { active: $setup.state.userMenu }]),
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.openMenu(0)))
        }, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("img", {
              src: _imports_1,
              class: _normalizeClass($setup.state.userMenu ? 'on' : 'off')
            }, null, 2),
            _createElementVNode("img", {
              src: _imports_2,
              class: _normalizeClass(!$setup.state.userMenu ? 'on' : 'off')
            }, null, 2)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("strong", null, _toDisplayString($setup.userInfo.name ? $setup.userInfo.name : $setup.userInfo.info.name), 1),
            _createTextVNode(" 님 " + _toDisplayString($setup.userInfo.id ? $setup.userInfo.id : $setup.userInfo.info.id), 1)
          ]),
          _createElementVNode("div", {
            class: "user_menu shadow",
            style: _normalizeStyle($setup.state.userMenu ? '' : 'display:none;')
          }, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openModal(0))),
                class: "my_info"
              }, "내정보"),
              _createElementVNode("li", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.logout && $setup.logout(...args))),
                class: "logout"
              }, "로그아웃")
            ])
          ], 4)
        ], 2)), [
          [_directive_click_outside, $setup.handleOutsideClick]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "setting",
          onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.openMenu(1)))
        }, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("img", {
              src: _imports_3,
              alt: "",
              style: _normalizeStyle($setup.state.settingMenu ? 'display:none;' : '')
            }, null, 4),
            _createElementVNode("img", {
              src: _imports_4,
              alt: "",
              style: _normalizeStyle($setup.state.settingMenu ? '' : 'display:none;')
            }, null, 4)
          ]),
          _createElementVNode("div", {
            class: "setting_menu shadow",
            style: _normalizeStyle($setup.state.settingMenu ? '' : 'display:none;')
          }, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.openModal(1)))
              }, "국가설정"),
              _createElementVNode("li", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.openModal(2)))
              }, "자동 모니터링 설정"),
              _createElementVNode("li", {
                onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.openModal(3)))
              }, "키워드"),
              _createElementVNode("li", {
                onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.router.push('/api/charge/log')))
              }, "API 충전 이력"),
              _createElementVNode("li", {
                onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.openModal(4)))
              }, "도움말")
            ])
          ], 4)
        ])), [
          [_directive_click_outside, $setup.handleOutsideClick2]
        ])
      ])
    ]),
    _createVNode(_component_ModalComponents, {
      title: $setup.modal.title,
      customClass: $setup.modal.customClass,
      type: $setup.modal.type,
      list: $setup.modal.list,
      columns: $setup.modal.fields,
      show: $setup.state.isModalOpen,
      no: $setup.modal.cancel,
      yes: $setup.modal.confirm,
      isBg: true,
      useBtn: $setup.modal.isBtn,
      onToggleNation: $setup.saveNations,
      onClose: $setup.modalClose
    }, null, 8, ["title", "customClass", "type", "list", "columns", "show", "no", "yes", "useBtn", "onToggleNation", "onClose"]),
    _createVNode(_component_UserModal, {
      userInfo: $setup.userInfo.info,
      show: $setup.state.isUserModal,
      onClose: $setup.modalClose
    }, null, 8, ["userInfo", "show", "onClose"]),
    ($setup.state.isKeywordModal)
      ? (_openBlock(), _createBlock(_component_KeywordModal, {
          key: 0,
          onClose: $setup.modalClose
        }, null, 8, ["onClose"]))
      : _createCommentVNode("", true),
    ($setup.state.isHelperModal)
      ? (_openBlock(), _createBlock(_component_HelperModal, {
          key: 1,
          onClose: $setup.modalClose
        }, null, 8, ["onClose"]))
      : _createCommentVNode("", true)
  ], 64))
}